var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDialogShow && _vm.popUpData.id)?_c('div',{staticClass:"container"},[_c('img',{staticClass:"content",attrs:{"src":_vm.popUpData.pop_up_image},on:{"click":_vm.jumpUrl}}),_c('img',{staticClass:"close",attrs:{"src":_vm.closeIcon,"alt":""},on:{"click":_vm.close}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }